export const NodeEnv = {
  development: 'development',
  production: 'production',
}

export const AppEnv = {
  development: 'development',
  staging: 'staging',
  production: 'production',
}
